import { ActivityPanel } from './ActivityPanel'
import { ContractList } from './ContractList'
import { DepthPanel } from './DepthPanel'
import { TradeChart } from './TradeChart'
import type { MarketState } from '../useMarketSocket'
import type { MarketPoint } from '../types'

/**
 * Piyasa sayfası — 2×2 yerleşim:
 *
 *   ┌───────────────────────┬────────────┐
 *   │ Kontratlar   (3/4)    │ Derinlik   │
 *   ├───────────────────────┼────────────┤
 *   │ Eşleşme grafiği (3/4) │ Sekmeler   │
 *   └───────────────────────┴────────────┘
 *
 * Üst satır alt satırdan yüksek: seçili kontrat şeridi kaldırılıp alanı
 * kontratlar ve emir defterine verildi.
 */

interface Props {
  state: MarketState
  marketData: Record<string, MarketPoint>
  now: number
  onSelect: (contract: string) => void
  /**
   * Telefon düzeni: bu sayfa yalnız KONTRAT LİSTESİ olur. Emir defteri, grafik
   * ve eşleşmeler ayrı bir ekrana (`TradePage`) taşınır — dördünü 375 pikselde
   * alt alta dizmek hiçbirini okunur bırakmıyordu.
   */
  mobil?: boolean
}

export function MarketPage({ state, marketData, now, onSelect, mobil = false }: Props) {
  const selected = state.selected
  const kapali = state.contracts.find((c) => c.key === selected)?.closed ?? false

  if (mobil) {
    return (
      <main className="mobil-piyasa">
        <ContractList
          contracts={state.contracts}
          board={state.board}
          marketData={marketData}
          own={state.own}
          selected={selected}
          now={now}
          onSelect={onSelect}
          mobil
        />
      </main>
    )
  }

  return (
    <main className="grid">
      <section className="cell cell-contracts">
        <ContractList
          contracts={state.contracts}
          board={state.board}
          marketData={marketData}
          own={state.own}
          selected={selected}
          now={now}
          onSelect={onSelect}
        />
      </section>

      <section className="cell cell-depth">
        <DepthPanel
          depth={state.depth}
          orders={state.orders}
          contract={selected}
          closed={kapali}
          mcp={selected ? (state.board[selected]?.mcp ?? null) : null}
        />
      </section>

      <section className="cell cell-chart">
        <TradeChart
          trades={state.trades}
          fills={state.fills}
          contract={selected}
          mcp={selected ? (state.board[selected]?.mcp ?? null) : null}
        />
      </section>

      <section className="cell cell-tape">
        <ActivityPanel
          trades={state.trades}
          fills={state.fills}
          contract={selected}
          contracts={state.contracts}
        />
      </section>
    </main>
  )
}
